<a routerLink="/staff" class="back-link">
  <mat-icon>arrow_back</mat-icon>
  Back to staff
</a>

<div class="page-header">
  <div>
    <h1>New Staff</h1>
    <p>Create an approval-desk account with a temporary password.</p>
  </div>
</div>

<div class="card-surface staff-create-card">
  <form [formGroup]="form" (ngSubmit)="submit()" class="staff-form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Display name</mat-label>
      <input matInput type="text" formControlName="displayName" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        @for (role of roles; track role) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Temporary password</mat-label>
      <input matInput type="password" formControlName="temporaryPassword" />
    </mat-form-field>

    @if (errorMessage(); as message) {
      <p class="staff-error">{{ message }}</p>
    }

    <button mat-flat-button color="primary" type="submit" [disabled]="loading()" class="staff-submit">
      @if (loading()) {
        <mat-spinner diameter="20" />
      } @else {
        Create Staff
      }
    </button>
  </form>
</div>
